import { Vue } from "Common/vue";

const catFilterElem = document.querySelector("#categoriesFilter");
const filterElem = document.getElementById("filter");

if (catFilterElem) {
    const productsCategories = catFilterElem.dataset.categories;
    const selectedCategoryId = catFilterElem.dataset.selected;
    const filterType = catFilterElem.dataset.filterType;

    new Vue({
        el: "#categoriesFilter",
        components: {
            CategoriesFilter: () => import("VueComponents/CategoriesFilter.vue"),
        },
        template: `<CategoriesFilter :select-category-id="${selectedCategoryId || null}" :products-categories="${productsCategories}" :filter-type="${filterType}"></CategoriesFilter>`,
    });
}

if (filterElem !== null) {
    filterElem.addEventListener("category.changed", function (e) {
        const categoryId = e.detail.category_id;
        const filterCategoryIdInput = document.getElementById("filterCategoryId");

        if (filterCategoryIdInput) {
            filterCategoryIdInput.value = categoryId;
        }
        Filter.submit();
    });
}
